const cameraSupport = () => navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function';

export {
  cameraSupport, // eslint-disable-line
};
